export interface ProductUsedIn {
  productKey: string;
  productDescription: string;
  productShortDescription: string;
  owner: string;
  productOldCode: string;
  productTypeDescription: string;
}
